<template>
  <div>
    <Loading v-if="loading"></Loading>
    <van-form @submit="handleSubmit">
      <DynamicForm ref="dynamicForm" v-model="formData" :form-config="formConfig">
        <template #cityId>
          <AreaSelect
            v-model="formData.cityId"
            label="地区"
            :disabled="isView"
          />
        </template>
      </DynamicForm>
      <div class="form-actions">
        <van-button
          v-if="!isView"
          type="primary"
          native-type="submit"
          :disabled="loading"
          class="action-btn"
        >
          保存
        </van-button>
        <van-button
          @click="handleClose"
          class="action-btn"
        >
          关闭
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import Loading from "../../components/loading.vue";
import DynamicForm from "../../components/DynamicForm.vue";
import AreaSelect from "../../components/AreaSelect.vue";
import * as supplierApi from "@/service/api/basedata/supplier";
import { MANAGE_TYPE } from "@/enums/manageType";
import { SETTLE_TYPE } from "@/enums/settleType";
import { STATUS } from "@/enums/status";
import pinyin from "js-pinyin";

export default {
  name: "SupplierDetail",
  components: {
    Loading,
    DynamicForm,
    AreaSelect,
  },
  data() {
    return {
      id: null,
      isView: true,
      loading: false,
      formData: {
        code: "",
        name: "",
        mnemonicCode: "",
        contact: "",
        telephone: "",
        email: "",
        zipCode: "",
        fax: "",
        cityId: "",
        address: "",
        loginUserName: "",
        loginPassword: "",
        manageType: "1",
        deliveryCycle: "",
        taxIdentifyNo: "",
        creditCode: "",
        settleType: 2,
        bankName: "",
        accountName: "",
        accountNo: "",
        description: "",
        available: true,
      },
    };
  },
  created() {
    this.id = this.$route.params.id === "add" ? null : this.$route.params.id;
    this.isView = this.$route.params.type === "view";
    if (this.id) {
      this.loadDetail();
    }
  },
  computed: {
    isNew() {
      return !this.id;
    },
    // 表单配置
    formConfig() {
      return [
        {
          tit: "个人信息",
          form: [
            {
              name: "code",
              label: "编号",
              required: true,
              disabled: this.isView,
            },
            {
              name: "name",
              label: "名称",
              required: true,
              disabled: this.isView,
            },
            {
              name: "mnemonicCode",
              label: "助记码",
              required: true,
              disabled: this.isView,
            },
            { name: "contact", label: "联系人", disabled: this.isView },
            {
              name: "telephone",
              label: "联系电话",
              disabled: this.isView,
              rules: [
                {
                  validator: (val) => /^1[3-9]\d{9}$/.test(val) || !val,
                  message: "请输入正确的手机号码格式",
                },
              ],
            },
            {
              name: "email",
              label: "电子邮箱",
              disabled: this.isView,
              rules: [
                {
                  validator: (val) => /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/.test(val) || !val,
                  message: "请输入正确的邮箱格式",
                },
              ],
            },
            {
              name: "zipCode",
              label: "邮编",
              disabled: this.isView,
              rules: [
                {
                  validator: (val) => /^\d{6}$/.test(val) || !val,
                  message: "请输入6位数字邮政编码",
                },
              ],
            },
            { name: "fax", label: "传真", disabled: this.isView },
            {
              name: "cityId",
              label: "地区",
              type: "slot",
              disabled: this.isView,
            },
            { name: "address", label: "详细地址", disabled: this.isView },
          ],
        },
        {
          tit: "添加账号",
          form: [
            {
              name: "loginUserName",
              label: "供应商账号",
              required: true,
              disabled: this.isView,
            },
            {
              name: "loginPassword",
              label: "供应商密码",
              required: true,
              disabled: this.isView,
              type: "password",
            },
          ],
        },
        {
          tit: "经营信息",
          form: [
            {
              name: "manageType",
              label: "经营方式",
              required: true,
              disabled: this.isView,
              type: "select",
              options: MANAGE_TYPE.getItems().map((item) => ({
                text: item.value,
                value: item.key,
              })),
            },
            {
              name: "deliveryCycle",
              label: "送货周期(天)",
              disabled: this.isView,
              type: "number",
            },
            {
              name: "taxIdentifyNo",
              label: "纳税人识别号",
              disabled: this.isView,
              rules: [
                {
                  validator: (val) => /^[0-9A-Za-z]{8,20}$/.test(val) || !val,
                  message: "纳税人识别号应为8-20位字母数字组合",
                },
              ],
            },
            {
              name: "creditCode",
              label: "信用代码",
              disabled: this.isView,
              rules: [
                {
                  validator: (val) => /^[0-9A-Za-z]{18}$/.test(val) || !val,
                  message: "统一社会信用代码应为18位",
                },
              ],
            },
          ],
        },
        {
          tit: "银行信息",
          form: [
            {
              name: "settleType",
              label: "结款方式",
              required: true,
              disabled: this.isView,
              type: "select",
              options: SETTLE_TYPE.getItems().map((item) => ({
                text: item.value,
                value: item.key,
              })),
            },
            { name: "bankName", label: "开户银行", disabled: this.isView },
            { name: "accountName", label: "户名", disabled: this.isView },
            {
              name: "accountNo",
              label: "银行账号",
              disabled: this.isView,
              rules: [
                {
                  validator: (val) => /^[0-9]{8,30}$/.test(val) || !val,
                  message: "银行账号应为8-30位数字",
                },
              ],
            },
          ],
        },
        {
          tit: "备注信息",
          form: [
            {
              name: "description",
              label: "备注",
              disabled: this.isView,
              type: "textarea",
            },
          ],
        },
        ...(this.isNew ? [] : [{
          tit: "状态",
          form: [
            {
              name: "available",
              label: "状态 ",
              required: true,
              disabled: this.isView,
              type: "switch",
            },
          ],
        }])
      ];
    },
  },
  watch: {
    "formData.name": {
      handler(newName) {
        if (this.isNew && newName) {
          this.generateMnemonicCode();
        }
      },
      immediate: false,
    },
    formData: {
      handler(newVal, oldVal) {
        console.log(
          newVal.manageType,
          typeof newVal.manageType,
          oldVal.manageType
        );
      },
      deep: true,
    },
  },
  methods: {
    generateMnemonicCode() {
      const name = this.formData.name || "";
      if (!name) {
        this.formData.mnemonicCode = "";
        return;
      }

      try {
        let mnemonic = pinyin.getCamelChars(name);
        console.log(mnemonic);
        mnemonic = mnemonic.replace(/[^A-Za-z0-9]/g, "");
        this.formData.mnemonicCode = mnemonic.toUpperCase();
      } catch (e) {
        console.warn("拼音转换失败:", e);
        let mnemonic = name.replace(/[^A-Za-z0-9]/g, "");
        this.formData.mnemonicCode = mnemonic.toUpperCase();
      }
    },
    loadDetail() {
      this.loading = true;
      supplierApi
        .get(this.id)
        .then((res) => {
          if (res.code === 200) {
            this.formData = {
              ...this.formData,
              ...res.data,
            };
          }
        })
        .catch((e) => {
          console.error(e);
          this.$toast.fail(e.msg);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSubmit() {
      // 表单必填校验
      const validation = this.$refs.dynamicForm.validate();
      if (!validation.valid) {
        this.$toast.fail(validation.errors[0]);
        return;
      }

      this.loading = true;
      const data = { ...this.formData };
      if (this.id) {
        data.id = this.id;
        supplierApi
          .update(data)
          .then((res) => {
            if (res.code === 200) {
              this.$toast.success("修改成功");
              this.$router.back();
            }
          })
          .catch((e) => {
            console.error(e);
            this.$toast.fail(e.msg);
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        supplierApi
          .create(data)
          .then((res) => {
            if (res.code === 200) {
              this.$toast.success("新增成功");
              this.$router.back();
            }
          })
          .catch((e) => {
            console.error(e);
            this.$toast.fail(e.msg);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    handleClose() {
      this.$router.push({ name: "supplier" });
    },
  },
};
</script>

<style lang="less" scoped>
.van-cell {
  padding: 5px 2px 2px 15px !important;
}
.form-actions {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 5px;
  background: #fff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  gap: 10px;
  z-index: 100;
}
.action-btn {
  flex: 1;
}
// 给表单底部留出空间，避免内容被按钮遮挡
.van-form {
  padding-bottom: 50px;
}
</style>
